export default __webpack_public_path__ + "static/media/SF-Pro-Rounded-Bold.016a0f34.otf";